import * as React from 'react';
import {
  BubbleOne,
  BubbleThree,
  BubbleTwoInner,
  BubbleTwoOutter,
  ColumnOne,
  InformationIcon,
  InformationTextDescription,
  InformationTextHeader,
  InformationTextWrapper,
  InformationWrapper,
  BottomBubbles,
} from './styles';

export const FistColumn = (): JSX.Element => (
  <ColumnOne>
    <div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
      <BubbleOne />
      <InformationWrapper>
        <div>
          <InformationIcon className="fas fa-chart-bar" />
        </div>
        <InformationTextWrapper>
          <InformationTextHeader> Simplified data managment</InformationTextHeader>
          <InformationTextDescription>
            Data handling made easy. Easy data uploads, update and querying
          </InformationTextDescription>
        </InformationTextWrapper>
      </InformationWrapper>
      <BubbleTwoOutter style={{ marginLeft: '10rem' }}>
        <BubbleTwoInner />
      </BubbleTwoOutter>
      <InformationWrapper>
        <div>
          <InformationIcon className="fas fa-book" />
        </div>
        <InformationTextWrapper>
          <InformationTextHeader> Easy exams management</InformationTextHeader>
          <InformationTextDescription>
            Oversee all exams activities with simple queries and easy navigation system
          </InformationTextDescription>
        </InformationTextWrapper>
      </InformationWrapper>
      <BubbleThree />
      <InformationWrapper>
        <div>
          <InformationIcon className="fas fa-file-invoice-dollar" />
        </div>
        <InformationTextWrapper>
          <InformationTextHeader>Easy report generation</InformationTextHeader>
          <InformationTextDescription>
            A fast and easy way to generate examination payment reports.
          </InformationTextDescription>
        </InformationTextWrapper>
      </InformationWrapper>
      <BottomBubbles>
        <BubbleOne />
        <BubbleTwoOutter style={{ marginRight: '5rem' }}>
          <BubbleTwoInner />
        </BubbleTwoOutter>
      </BottomBubbles>
    </div>
  </ColumnOne>
);
